import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-slideshow',
  templateUrl: './slideshow.component.html',
  styleUrls: ['./slideshow.component.scss'],
})

export class SlideshowComponent {
  slides: any[] = [];
  ngOnInit() {

    this.slides = [
      { image: 'doctor-on-demand.png', header: 'Doctor-on-Demand', content: '24/7 GP Service included <br/>on all policies' },
      { image: 'membership-benefits.png', header: 'Membership Benefits', content: 'Save thousands with +300 retail <br/>discounts and cashback' },
      { image: 'critical-illness-cover.png', header: '200% Critical Illness Cover', content: 'Protection with up to 3 benefit <br/>claims (not just 1)' },
      { image: 'dual-life-cover.png', header: '200% Dual Life Cover', content: 'Covers both partners <br/>(not just 1)'},
    ];
  }  
  
  showImage(slide: any) {
    let img = slide.image;
    return `${environment.imageBase}/assets/slideshow/${img}`;
  }
}
